export default __webpack_public_path__ + "static/media/4.f707469d.svg";